import React, { useEffect, useState } from 'react'

import { InputAdornment, SvgIcon } from '@material-ui/core'
import { CancelOutlined, Menu } from '@material-ui/icons'
import TextField from '../components/TextField.js'
import { HEADER_BACKGROUND, HEADER_HEIGHT } from '../styles.js'

const ENTER = ['Enter', 'NumpadEnter']

const Header = ({
  title,
  value,
  onSearchChange,
  onLogoClick
}) => {
  const [search, setSearch] = useState(value || '')
  const buttonEnabled = search.length > 0

  useEffect(() => {
    setSearch(value || '')
  }, [value])

  const resetSearch = () => {
    if (buttonEnabled) {
      setSearch('')
      onSearchChange('')
    }
  }

  const doSearch = () => onSearchChange(search)
  const onChange = (event) => {
    const nextValue = event.target.value
    setSearch(nextValue)
    if (nextValue === '') {
      onSearchChange('')
    }
  }

  const onKeyPress = (event) => {
    if (ENTER.includes(event.key)) {
      doSearch()
    }
  }

  const inputProps = {
    style: {
      background: 'white',
      borderRadius: 6,
      height: 36
    },
    inputProps: {
      style: searchInputTextStyle
    },
    endAdornment: (
      <InputAdornment position='end' style={endAdornmentStyle}>
        <CancelOutlined
          style={closeButtonStyle(buttonEnabled)}
          onClick={resetSearch}
        />
      </InputAdornment>
    )
  }

  return (
    <div style={headerStyle}>
      <div style={{ display: 'flex', alignItems: 'center', width: '50%' }}>
        {typeof onLogoClick === 'function'
          ? <HeaderLogo onClick={onLogoClick} />
          : <a href={process.env.REACT_APP_CM_URL} target='_new' rel='noreferrer'><HeaderLogo /></a>}
        <span style={titleStyle}>{title}</span>
      </div>
      {onSearchChange && (
        <div style={headerSearchAreaStyle}>
          <div style={searchWrapperStyle}>
            <TextField
              fullWidth
              value={search}
              onChange={onChange}
              InputProps={inputProps}
              style={searchFieldStyle}
              onKeyPress={onKeyPress}
            />
          </div>
          <div style={{ width: '20px' }} />
        </div>
      )}
    </div>
  )
}

const closeButtonStyle = (enabled) => {
  return {
    cursor: 'pointer',
    marginLeft: 0,
    marginRight: 0,
    color: enabled ? '#333333' : '#888888'
  }
}

const endAdornmentStyle = {
  marginLeft: -4,
  marginRight: -8
}

const titleStyle = {
  color: '#ffffff',
  marginLeft: 10
}

const headerStyle = {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  background: HEADER_BACKGROUND,
  height: 50
}

const headerSearchAreaStyle = {
  position: 'absolute',
  right: 12,
  // Keep default in expanded position over title area, clear of logo.
  left: 120,
  zIndex: 2,
  display: 'flex',
  alignItems: 'center',
  gap: 4
}

const searchWrapperStyle = {
  flex: 1
}

const searchFieldStyle = {
  width: '100%',
  marginTop: 0,
  marginBottom: 0
}

const searchInputTextStyle = {
  paddingLeft: 8,
  paddingRight: 8
}

const headerLogoStyle = {
  cursor: 'pointer',
  color: '#ffffff',
  fontSize: 24,
  marginLeft: 12
}

const HeaderLogo = ({ onClick }) => (
  <Menu style={headerLogoStyle} onClick={onClick} />
)

export const PergasIcon = ({ onClick, style, singleColor }) => {
  const color = typeof singleColor === 'string' && singleColor.length > 0 ? singleColor : null
  return (
    <SvgIcon
      style={{ cursor: 'pointer', height: HEADER_HEIGHT, paddingLeft: '15px', ...style }}
      viewBox='0 0 87 87'
      onClick={onClick}
    >
      <g id='Group_12901' transform='translate(3357.426 1104.298)'>
        <path id='Path_8433' d='M2.52,0,48.511,11.671a2.386,2.386,0,0,1,2.52,2.223V63.358a2.386,2.386,0,0,1-2.52,2.223L2.52,53.354A2.386,2.386,0,0,1,0,51.131V2.223A2.386,2.386,0,0,1,2.52,0Z' transform='translate(-3321.456 -1104.298)' fill={color || '#073a53'} />
        <path id='Path_8363' d='M2.52,0,48.511,11.671a2.386,2.386,0,0,1,2.52,2.223V63.358a2.386,2.386,0,0,1-2.52,2.223L2.52,53.354A2.386,2.386,0,0,1,0,51.131V2.223A2.386,2.386,0,0,1,2.52,0Z' transform='translate(-3339.441 -1094.099)' fill={color || '#4d84a0'} />
        <g id='Group_12898' transform='translate(-3357.426 -1081.597)'>
          <g id='Group_12875'>
            <path id='Path_8422' d='M2.524,0,48.551,11.443a2.37,2.37,0,0,1,2.523,2.177v48.5A2.369,2.369,0,0,1,48.556,64.3h0L2.524,52.31A2.37,2.37,0,0,1,0,50.133V2.181A2.369,2.369,0,0,1,2.519,0h0' transform='translate(0 0)' fill={color || '#9aadba'} />
            <path id='Path_8423' d='M54.8,52.772,27.632,45.708a2.58,2.58,0,0,0-3.4,2.615V79.806l6.791-5.23L54.8,80.756a2.58,2.58,0,0,0,3.4-2.615V57.153a4.787,4.787,0,0,0-3.4-4.381' transform='translate(-14.743 -32.793)' fill={color || '#fff'} />
          </g>
        </g>
      </g>
    </SvgIcon>
  )
}

export default Header
